import Footer from "../Footer";
import { featuredArticle } from "../../data/featuredArticle";
import "../../styles/SecurityAlertArticlePage.css";
import illustrationSrc from "../../assets/images/alerte_securite.jpg";

const SecurityAlertArticlePage = () => {
  return (
    <div className="article-page">
      <main className="article-page__content">
        <a href="/#home" className="article-page__back-link">
          Retour à l'accueil
        </a>

        <p className="article-page__kicker">Conseil prévention</p>
        <h1 className="article-page__title">{featuredArticle.title}</h1>

        <figure className="article-page__illustration-wrapper">
          <img
            className="article-page__illustration"
            src={illustrationSrc}
            alt="Illustration de prévention contre les faux virus Windows"
          />
        </figure>

        <section className="article-page__section">
          <p>
            Des fenêtres peuvent prétendre que votre PC est infecté et vous
            demandent d'appeler un numéro. C'est une arnaque. Microsoft ne
            demande jamais d'appeler via une popup.
          </p>
        </section>

        <section className="article-page__section">
          <h2>Réagissez immédiatement</h2>
          <ul className="article-page__checklist">
            <li>
              <span className="article-page__danger">❌</span> Ne cliquez sur
              rien
            </li>
            <li>
              <span className="article-page__danger">❌</span> N'appelez pas
            </li>
            <li>
              <span className="article-page__safe">✅</span> Fermez la page (Alt
              + F4 ou Gestionnaire des tâches)
            </li>
            <li>
              <span className="article-page__safe">✅</span> Redémarrez si
              besoin
            </li>
          </ul>
        </section>

        <section className="article-page__section">
          <h2>Nettoyage rapide</h2>
          <ul>
            <li>
              Supprimez historique, cookies et cache (via vos navigateurs ou
              CCleaner)
            </li>
            <li>Vérifiez vos extensions</li>
            <li>Lancez une analyse antivirus</li>
          </ul>
        </section>

        <section className="article-page__section article-page__highlight">
          <h2>Ce qu'il faut retenir</h2>
          <p>
            Une vraie alerte Windows n'affiche jamais de numéro et ne bloque pas
            votre écran. De plus, elle s'afficherait par-dessus votre navigateur
            et ne prendrait jamais sa place. En cas d'erreur critique,
            l'ordinateur s'éteindrait seul.
          </p>
        </section>

        <p className="article-page__closing">Je reste à votre disposition.</p>
      </main>

      <Footer />
    </div>
  );
};

export default SecurityAlertArticlePage;
